module.exports = __webpack_public_path__ + "static/media/Partner6.13ad3b21.webp";